import React from 'react';

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';

type Props = {
    onClick: () => void;
};
const RetakeRecordingButton: React.FC<Props> = ({ onClick }) => {
    return (
        <Button
            text="Retake"
            color={BUTTON_COLORS.TERTIARY}
            variant={BUTTON_VARIANTS.OUTLINE}
            iconLeft="replay"
            onClick={onClick}
        />
    );
};
export default React.memo(RetakeRecordingButton);
